module.exports = __webpack_public_path__ + "img/certificate-check.d12fb4b3.svg";